import { createTheme, ITheme } from '@fluentui/style-utilities';
import { IPartialExtendedTheme } from '@uifabric/portal-ux/lib/styling';

/* Converts the font size in px to rem based on the default font size of 16px 
https://github.com/microsoft/fluentui/blob/master/packages/fluentui/react-northstar/src/utils/fontSizeUtility.ts */
export const appTheme = createTheme({
  fonts: {
    tiny: { fontSize: '0.625rem' }, //10px
    xSmall: { fontSize: '0.625rem' }, //10px
    small: { fontSize: '0.75rem' }, //12px
    smallPlus: { fontSize: '0.75rem' }, //12px
    medium: { fontSize: '0.875rem' }, //14px
    mediumPlus: { fontSize: '1rem' }, //16px
    large: { fontSize: '1.125rem' }, //18px
    xLarge: { fontSize: '1.25rem' }, //20px
    xLargePlus: { fontSize: '1.5rem' }, //24px
    xxLarge: { fontSize: '1.75rem' }, //28px
    xxLargePlus: { fontSize: '2rem' }, //32px
    superLarge: { fontSize: '2.625rem' }, //42px
    mega: { fontSize: '4.25rem' } //68px
  }
});

export function getOfficeTheme(): ITheme {
  const background = '#f5f3f1';
  const primary = '#6e6d6c';

  const headerBackground = background;
  const headerBackgroundSearch = background;
  const headerBrandText = primary;
  const headerTextIcons = primary;
  const headerSearchButtonBackground = background;
  const headerSearchFilters = background;
  const headerButtonsBackground = background;
  const headerButtonsBackgroundHover = '#CCC2B8';
  const headerButtonsBackgroundSearch = background;
  const headerButtonsBackgroundSearchHover = background;
  const headerImage = background;
  const headerImageStatic = background;
  const headerSearchBoxBackground = background;
  const headerSearchBoxIcon = background;
  const headerSearchPlaceholderText = primary;
  const headerSearchButtonBackgroundHover = '#CCC2B8';
  const headerSearchButtonIcon = background;
  const headerSearchFiltersHover = '#CCC2B8';
  const headerBadgeBackground = background;
  const headerBadgeText = primary;
  const headerSearchIcon = background;

  const theme = {
    themePrimary: primary,
    headerBackground,
    headerSearchButtonBackground,
    headerSearchFilters,
    headerTextIcons,
    headerBackgroundSearch,
    headerButtonsBackground,
    headerButtonsBackgroundHover,
    headerButtonsBackgroundSearch,
    headerButtonsBackgroundSearchHover,
    headerBrandText
  };

  const normalizedTheme = {
    palette: theme,
    semanticColors: {
      headerImage,
      headerImageStatic,
      headerBackground,
      headerBackgroundSearch,
      headerBrandText,
      headerTextIcons,
      headerSearchBoxBackground,
      headerSearchBoxIcon,
      headerSearchPlaceholderText,
      headerSearchButtonBackground,
      headerSearchButtonBackgroundHover,
      headerSearchButtonIcon,
      headerSearchFilters,
      headerSearchFiltersHover,
      headerButtonsBackground,
      headerButtonsBackgroundHover,
      headerButtonsBackgroundSearch,
      headerButtonsBackgroundSearchHover,
      headerBadgeBackground,
      headerBadgeText,
      headerSearchIcon,
      buttonBorder: background
    },
  } as IPartialExtendedTheme;
  const finalTheme = createTheme(normalizedTheme);
  return finalTheme;
}